import { Link } from 'react-router-dom';
import { FooterProps } from '../types';
import { ARIA_LABELS } from '../../utils/constants';

export const Footer: React.FC<FooterProps> = ({ contactEmail, links, copyright }) => {
  return (
    <footer className="bg-panelGray border-t border-[#1E1E1E]">
      <div className="max-w-7xl mx-auto px-6 pt-32 pb-12 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-wide text-gorillaGold mb-4">
              Contact
            </h3>
            <a
              href={`mailto:${contactEmail}`}
              className="text-secondary hover:text-gorillaGold transition-colors text-xs tracking-[-0.02em]"
              aria-label={ARIA_LABELS.EMAIL_LINK}
            >
              {contactEmail}
            </a>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-wide text-gorillaGold mb-4">
              Links
            </h3>
            <ul className="space-y-2">
              {links.map((link) => (
                <li key={link.type}>
                  <a
                    href={link.url}
                    className="text-secondary hover:text-gorillaGold transition-colors text-xs tracking-[-0.02em]"
                    target={link.url.startsWith('http') ? '_blank' : undefined}
                    rel={link.url.startsWith('http') ? 'noopener noreferrer' : undefined}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-wide text-gorillaGold mb-4">
              Legal
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy"
                  className="text-secondary hover:text-gorillaGold transition-colors text-xs"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-borderGray">
          <p className="text-xs text-secondary text-center">{copyright}</p>
        </div>
      </div>
    </footer>
  );
};
